<template>
  <div class="main">
    <van-image
      fit="cover"
      src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/10.jpg"
      class="banner"
    />
    <!-- 产品介绍 -->
    <Introduce :title="'产品介绍'" :desc="desc" :img="img"></Introduce>
    <!-- 产品特点 -->
    <Constitute :title="'产品特点'" background="#fff" :constitute="constitute" class="constitute"></Constitute>
    <!-- 多端支持 -->
    <Module title="多端支持" :list="plan"></Module>
  </div>
</template>
<script>
import Introduce from '@/component/introduceModel';
import Constitute from '@/component/constitute';
import Module from '@/component/module';
export default {
  components: {
    Introduce,
    Constitute,
    Module
  },
  data() {
    return {
      desc:
        '灵匠平台是一款基于3D模型课件和知识点标签为教师和学生打造真实的实训场景，同时支持多人互动和多端适配，让教师在虚拟环境中完成授课，学生以多人互动和自主学习的方式学习和实操，多人互动学习调动学生自主学习、激发学生创新能力、培养团队精神。',
      img:
        'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/11.png?x-oss-process=image/resize,m_fill,h_430,w_520',
      list: [1, 2, 3, 4],
      plan: [
        {
          title: 'PC',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/12.png'
        },
        {
          title: '大屏设备',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/13.png'
        },
        {
          title: 'HTC vive',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/14.png'
        },
        {
          title: '未来感知',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/15.png?x-oss-process=image/resize,m_fill,h_200,w_200'
        }
      ],
      location: [
        {
          title: '灵活的教学模式',
          desc: '教师控播、学生控播、双人模式、自由模式、自主学习',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/5.png'
        },
        {
          title: '丰富的课件资源',
          desc: '机械类3D模型',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/6.png'
        },
        {
          title: '多终端设备支持',
          desc: 'PC、大屏、燧光MR、未来感知、HTC vive、安卓Pad',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/7.png'
        },
        {
          title: '多维度数据统计分析',
          desc: '设备和课件为维度，统计教学和学习数据',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/8.png'
        },
        {
          title: '',
          desc: '',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/9.png'
        }
      ],
      constitute: [
        {
          title: '灵活的教学模式',
          desc: '教师学生控播，双人、自由模式，自主学习',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/1.png'
        },
        {
          title: '丰富的课件资源',
          desc: '机械类、工程类等13个分子学科3D模型',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/2.png'
        },
        {
          title: '多终端设备支持',
          desc: 'PC、大屏、燧光MR、未来感知、HTC vive、安卓',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/3.png'
        },
        {
          title: '多维度数据分析',
          desc: '按学科设备等多维度，统计教学数据',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/4.png'
        }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.main {
  .banner {
    width: 100%;
    height: 500px;
    display: block;
  }
  .location {
    width: 1200px;
    height: 522px;
    margin: 0 auto;
    .title {
      margin-top: 124px;
      text-align: center;
      font-size: 42px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.6);
      line-height: 1;
    }
    .content {
      display: flex;
      align-items: center;
      margin-top: 33px;
      justify-content: space-between;
      .list {
        width: 224px;
        height: 303px;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid;
        border-image: linear-gradient(
            180deg,
            rgba(157, 157, 157, 0),
            rgba(99, 99, 99, 0.3)
          )
          1 1;
        text-align: center;
        padding: 0 30px;
        box-sizing: border-box;
        overflow: hidden;
        img {
          width: 60px;
          height: 60px;
          margin: 0 auto;
          margin-top: 10px;
          display: block;
        }
        .headline {
          font-size: 36px;
          font-weight: bold;
          color: #5e5e5e;
          line-height: 54px;
          margin-top: 18px;
        }
        .desc {
          margin-top: 10px;
          font-size: 24px;
          font-weight: 300;
          color: #5e5e5e;
          line-height: 36px;
        }
      }
    }
  }
  .offline {
    width: 1200px;
    margin: 0 auto;
    padding: 44px 0 137px 0;
    .title {
      font-size: 42px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.6);
      line-height: 1;
      text-align: center;
    }
    .content {
      width: 100%;
      height: 505px;
      position: relative;
      padding-right: 695px;
      box-sizing: border-box;
      margin-top: 50px;
      img {
        width: 449px;
        height: 225px;
      }
      img:nth-child(2) {
        margin-top: 55px;
      }
      img:nth-child(3) {
        position: absolute;
        top: 0;
        right: 0;
        width: 695px;
        height: 100%;
      }
    }
  }
  .case {
    width: 100%;
    background: #fff;
    > div {
      width: 1200px;
      height: 691px;
      margin: 0 auto;
      padding-top: 1px;
      .title {
        font-size: 42px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.6);
        line-height: 1;
        text-align: center;
        margin-top: 48px;
      }
      .content {
        width: 100%;
        display: flex;
        height: 391px;
        margin-top: 49px;
        .hasImg {
          width: 33.3%;
          height: 100%;
          box-sizing: border-box;
          border-right: 1px solid #dadada;
          padding: 0 30px;
          &:nth-child(3) {
            border: none;
          }
          img {
            width: 100%;
            height: 200px;
          }
          .headline {
            margin-top: 40px;
            line-height: 1;
            font-size: 28px;
            font-weight: bold;
            color: #9fa1b4;
            display: block;
            &:nth-of-type(2) {
              margin-top: 10px;
            }
          }
          .desc {
            display: block;
            font-size: 18px;
            font-weight: 400;
            color: #9fa1b4;
            line-height: 24px;
            margin-top: 20px;
          }
        }
        .noImg {
          width: 33.3%;
          height: 100%;
          > div {
            width: 100%;
            padding: 15px;
            box-sizing: border-box;
            &:last-child {
              border-top: 1px solid #dadada;
            }
            .headline {
              font-size: 28px;
              font-weight: bold;
              color: #9fa1b4;
              line-height: 40px;
              min-height: 92px;
            }
            .desc {
              font-size: 18px;
              font-weight: 400;
              color: #9fa1b4;
              line-height: 24px;
              margin-top: 20px;
            }
          }
        }
      }
      .more {
        margin-top: 64px;
        display: flex;
        justify-content: center;
        span {
          font-size: 24px;
          color: #9fa1b4;
          line-height: 1;
        }
        img {
          width: 22px;
          height: 18px;
        }
      }
    }
  }
  .plan{
    margin-bottom: 100px;
  }
}
@media (max-width: 1000px) {
  .main{
    .banner {
      width: 100%;
      height: 348px;
      display: block;
    }
    .constitute{
      background-color: #9AA4B9;
    }
    .plan{
      margin-bottom: 0;
    }
  }
}
</style>
